import React from "react";
// import { Link } from 'react-router-dom'
import Project from "../components/Project";
import { RoomContext } from "../context";
// potřebuju sem dostat API, z toho vzít vždy určitý type (kitchen, room, etc.) a vyrenderovat ho

import NavbarClear from "../components/NavbarClear";
import SideHero from "../components/SideHero";
// import Figure from '../components/Figure'
import Filter from "../components/Filter";
import Cta from "../components/Cta";
import Footer from "../components/Footer";

export default class Projects extends React.Component {
  static contextType = RoomContext;
  render() {
    // let { projects } = this.context;
    // projects = projects.map((project) => {
    //   if (project.type === "kitchen") {
    //     return (
    //       // <Project key={project.id} project={project} type={project.type} />
    //       <img src={project.fields.images.fields.file.url}></img>
    //     );
    //   }
    // });

    return (
      <div className="offWhiteBackground">
        <NavbarClear logo="https://www.nabytekbatka.cz/BatkaSmall.svg" />
        <SideHero />
        <h1 className="projects-title">ukázky naší práce</h1>
        <Filter category="kuchyně" />
        {/* <div className="projects-grid">{projects.fields.images}</div> */}
        <div className="kuchyne__grid">
          <div className="grid__pic navysku"><img src="https://www.nabytekbatka.cz/kuchyne/IMG_4542.JPG" alt="" /></div>
          <div className="grid__pic navysku"><img src="https://www.nabytekbatka.cz/kuchyne/IMG_4543.JPG" alt="" /></div>
          <div className="grid__pic"><img src="https://www.nabytekbatka.cz/kuchyne/modra.jpg" alt="" /></div>
          <div className="grid__pic"><img src="https://www.nabytekbatka.cz/kuchyne/IMG_4537.JPG" alt="" /></div>
          <div className="grid__pic navysku"><img src="https://www.nabytekbatka.cz/kuchyne/IMG_4557.JPG" alt="" /></div>
          <div className="grid__pic navysku"><img src="https://www.nabytekbatka.cz/kuchyne/IMG_4525.JPG" alt="" /></div>
          <div className="grid__pic navysku"><img src="https://www.nabytekbatka.cz/kuchyne/IMG_4551.JPG" alt="" /></div>
        </div>
        <Cta />
        <Footer />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Kitchen.js